import glassDefenseImage from "../../assets/blog/padel-glass-defense-action.webp";

export const padelGlassDefense = {
  id: 4,
  slug: "padel-glass-defense",
  title: "Padel Glass Defense: How to Defend Rebounds",
  excerpt: "The glass is your friend, not your enemy. Learn the basics of reading rebounds and turning defense into offense.",
  seoTitle: "Padel Glass Defense: How to Play Rebounds | Racketly",
  seoDescription: "Learn how to defend off the glass in padel. Read the rebound, choose your position and turn a defensive shot into a chance to recover control of the rally.",
  date: "2026-01-01",
  category: "Padel",
  image: glassDefenseImage,
  imageWidth: 1200,
  imageHeight: 1800,
  imageAlt: "A woman preparing to play a padel ball beside the glass wall",
  imageCaption: "Preparing for the next ball on a glass-walled padel court.",
  imageCredit: "Anhelina Vasylyk on Pexels",
  imageCreditUrl: "https://www.pexels.com/photo/woman-playing-padel-tennis-indoors-with-focus-35248286/",
  imageLicense: "Pexels License",
  imageLicenseUrl: "https://www.pexels.com/license/",
  imagePosition: "center 44%",
  content: `
  <p class="mb-4">For beginners, the glass walls in Padel can be intimidating. However, mastering the rebounding ball is what elevates a player from beginner to intermediate mastery.</p>

  <h2 class="text-xl font-bold mb-3 mt-6">Why Let it Pass?</h2>
  <p class="mb-4">Many beginners panic and volley balls from the back of the court. Letting the ball hit the glass slows it down, giving you more time to prepare your shot. It essentially gives you a "second life" in the point.</p>

  <h2 class="text-xl font-bold mb-3 mt-6">Reading the Rebound</h2>
  <p class="mb-4">The key is early preparation. As soon as the ball passes you, turn your body sideways and move with the ball towards the back glass. </p>
  <ul class="list-disc list-inside mb-4 ml-4">
    <li>If the ball is fast, it will come off the glass further. Step away from the glass.</li>
    <li>If the ball is slow aka "dying", you need to get closer and shovel it up.</li>
  </ul>

  <h2 class="text-xl font-bold mb-3 mt-6">The Counter-Attack</h2>
  <p class="mb-4">Once you are comfortable defending, look for the "Bajada". If the ball rebounds high, you can hit down on it aggressively, turning a defensive situation into an attacking winner.</p>
`,
};
